import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useMutation } from 'Data/Api.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'
import { useDataSubmit, useDataValue } from 'Simple/Data.js'
import mutation from './mutation.graphql.js'

export default function useDataOnSubmit(props) {
  let id = useDataValue({
    viewPath: props.viewPath,
    context: 'event',
    path: 'appointment.booking._id',
  })
  let submit = useDataSubmit({
    context: 'events',
    viewPath: props.viewPath,
  })
  let [, notify] = useNotifications()
  let setFlowTo = useSetFlowTo(props.viewPath)

  let [, executeMutation] = useMutation(mutation)

  return async function onSubmit({ value }) {
    if (!value.chair_id || !value.provider_id || !value.assistant_id) {
      return true
    }

    let mutationResponse = await executeMutation({
      id,
      provider_id: value.provider_id,
      assistant_id: value.assistant_id,
      chair_id: value.chair_id,
    })
    if (mutationResponse.error) {
      notify(
        notifyError(
          `There was a problem updating the appointment. Please try again.`
        )
      )
      return
    }

    submit({ type: 'reFetch' })
    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
